<template>
  <div style="display: inline">
    <!-- 商家远程搜索的组件 -->
    <el-select
      v-model="supply_id"
      :remote-method="fetchSupply"
      placeholder="商家"
      remote
      filterable
      @change="change"
    >
      <el-option value="0" label="全部"></el-option>
      <el-option
        v-for="item in supply_options"
        :key="item.supply_id"
        :value="item.supply_id"
        :label="item.supply_name"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      supply_options: [],
      supply_id: "",
    };
  },

  methods: {
    fetchSupply(e) {
      if (typeof e == "string" && e.length > 2) {
        this.$http
          .post("/erp/Common/selectSupply", { supply_name: e })
          .then((res) => {
            if (res.data.code != 200) {
              return this.$message.error(res.data.msg);
            }
            this.supply_options = res.data.data;
          });
      }
    },
    change(e) {
      this.$emit("change", e);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/supplySelect.vue